import React from "react";
import { Image } from "antd";
import Icon from "@ant-design/icons";

import CyberCats from "assets/images/aboutTheGame/cybercats.png"
import CyberCatsBig from "assets/images/aboutTheGame/cybercats_big.jpg"
import GamePaths from "assets/images/aboutTheGame/game_paths.png";
import GamePathsBig from "assets/images/aboutTheGame/game_paths_big.png";
import WorkBig from "assets/images/aboutTheGame/work_big.png";
import Work from "assets/images/aboutTheGame/work.png";
import Nfts from "assets/images/aboutTheGame/nfts.png";
import NftsBig from "assets/images/aboutTheGame/nfts_big.jpg";
import {CircleIcon} from "./components/CircleIcon";
import {AnchorIcon} from "./components/AnchorIcon";
import {CurveIcon} from "./components/CurveIcon";

import { ReactComponent as ImagePlaceholder } from "assets/icons/image-placeholder.svg";

import "./MainAboutGame.scss";

export const MainAboutGame: React.FC = () => {
  return (
    <div className="main-about-game" id="the-game">
      <div className="card reversed">
        <div className="card-image">
          <Image
            src={CyberCats}
            preview={{
              src: CyberCatsBig,
              mask: (
                <Icon
                  component={ImagePlaceholder}
                  style={{ fontSize: "4rem" }}
                />
              ),
            }}
          />
          </div>
        <div className="card-content">
          <p className="card-title">Abandoned. Worthless. Neuroborn.</p>
          <p className="card-text">
            Welcome to Gatia — a planet where lab-grown neurocats like you get tossed onto the trash heaps of Miut megacity. Your goal? Not to survive. To gnaw out your place under this filthy sky. Claws, neuro-implants, or cold calculation — anything goes in this cynical hellhole. Forget political correctness: here, swearing is small talk, violence is an argument, and sex is bargaining chips. 18+ isn’t a rating — it’s our brand.
          </p>
        </div>
      </div>
      <div className="card">
        <div className="card-image">
          <Image
            src={Work}
            preview={{
              src: WorkBig,
              mask: (
                <Icon
                  component={ImagePlaceholder}
                  style={{ fontSize: "4rem" }}
                />
              ),
            }}
          />
        </div>
          <div className="card-content">
            <p className="card-title">Start at rock bottom:</p>
            <div className="card-list">
              <div className="card-list-item">
                <CircleIcon className="card-icon-circle"/>
                <span className="card-text">Brawling with mutants over scraps? Just last night for you.</span>
              </div>
              <div className="card-list-item">
                <CircleIcon className="card-icon-circle"/>
                <span className="card-text">Grinding for credits in toxic factories? Be glad you’re not raw material.</span>
              </div>
              <div className="card-list-item">
                <CircleIcon className="card-icon-circle"/>
                <span className="card-text">Running errands for crime syndicates? Not your syndicates... yet.</span>
              </div>
            </div>
          </div>
      </div>
      <div className="card reversed">
        <div className="card-image">
          <Image
            src={GamePaths}
            preview={{
              src: GamePathsBig,
              mask: (
                <Icon
                  component={ImagePlaceholder}
                  style={{ fontSize: "4rem" }}
                />
              ),
            }}
          />
        </div>
          <div className="card-content">
            <p className="card-title">Rise to the top — or burn it down:</p>
            <div className="card-list">
              <div className="card-list-item">
                <AnchorIcon className="card-icon-anchor"/>
                <span className="card-text">Own factories where yesterday’s "colleagues" grind themselves to dust, wired to cheap neurostimulators. Build supply chains, hire players, pay them peanuts — or burn rivals with a smile.</span>
              </div>
              <div className="card-list-item">
                <AnchorIcon className="card-icon-anchor"/>
                <span className="card-text">Run a syndicate that has entire districts by the balls. Trade guns, bodies, or influence — just make sure the tokens flow.</span>
              </div>
              <div className="card-list-item">
                <AnchorIcon className="card-icon-anchor"/>
                <span className="card-text">Master dozens of paths: killing machine, economic mogul, shadow shark — or all at once. Level up combat skills, gang management, assassin tech. A ceiling? Doesn’t fucking exist.</span>
              </div>
            </div>
          </div>
      </div>
      <div className="card">
        <div className="card-image">
          <Image
            src={Nfts}
            preview={{
              src: NftsBig,
              mask: (
                <Icon
                  component={ImagePlaceholder}
                  style={{ fontSize: "4rem" }}
                />
              ),
            }}
          />
        </div>
        <div className="card-content">
          <p className="card-title">This isn’t a game. <br/> It’s your digital asset:</p>
          <div className="card-list">
            <div className="card-list-item">
              <CurveIcon className="card-icon-curve"/>
              <span className="card-text">Rare loot, land, entire enterprises — yours as NFTs. Full ownership. Resell anytime. Built an empire? Sell it. Found a legendary artifact?<br/>That’s your digital trophy.</span>
            </div>
            <div className="card-list-item">
              <CurveIcon className="card-icon-curve"/>
              <span className="card-text">Runs in any browser. No wallet needed to start. No investment.</span>
            </div>
          </div>
          <p className="card-subtitle">Enough with sterile sandboxes.</p>
          <span className="card-text">
          Start your climb from the gutter to crypto-power. <br/>Take your slice of Gatia — by force.
          </span>
          <p className="card-note"><i>Note: Contains explicit violence, sex, pervasive profanity, and dark humor. 18+.</i></p>
        </div>
      </div>
    </div>
  );
};
